import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/overview-icon-black.svg'
import _imports_1 from '@/assets/icons/house-icon-black.svg'
import _imports_2 from '@/assets/icons/messages-icon-black.svg'
import _imports_3 from '@/assets/icons/customer-offers.svg'
import _imports_4 from '@/assets/icons/document-icon-black.svg'
import _imports_5 from '@/assets/icons/private-loan-icon-black.svg'
import _imports_6 from '@/assets/icons/user-icon-black.svg'
import _imports_7 from '@/assets/icons/logout-icon-plain.svg'


const _hoisted_1 = {
  key: 0,
  class: "nav flex-column mb-auto"
}
const _hoisted_2 = { class: "nav-item" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-2",
  height: "20",
  src: _imports_0
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Logga in", -1)
const _hoisted_5 = {
  key: 1,
  class: "nav flex-column mb-auto"
}
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-2",
  height: "20",
  src: _imports_1
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Bolån", -1)
const _hoisted_9 = {
  key: 0,
  class: "badge rounded-pill bg-danger ms-2"
}
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-2",
  height: "16",
  src: _imports_2
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Meddelanden", -1)
const _hoisted_13 = {
  key: 0,
  class: "badge rounded-pill bg-danger ms-2"
}
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-2",
  height: "20",
  src: _imports_3
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Erbjudanden", -1)
const _hoisted_17 = {
  key: 0,
  class: "badge rounded-pill bg-danger ms-2"
}
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-2",
  height: "22",
  src: _imports_4
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Rådgivning", -1)
const _hoisted_21 = {
  key: 0,
  class: "badge rounded-pill bg-danger ms-2"
}
const _hoisted_22 = { class: "nav-item" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-2",
  height: "20",
  src: _imports_5
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "Privatlån", -1)
const _hoisted_25 = {
  key: 0,
  class: "badge rounded-pill bg-danger ms-2"
}
const _hoisted_26 = { class: "nav flex-column mt-auto" }
const _hoisted_27 = { class: "nav-item" }
const _hoisted_28 = {
  key: 0,
  class: "nav-link"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-2",
  height: "20",
  src: _imports_6
}, null, -1)
const _hoisted_30 = { class: "nav-item" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-2",
  height: "18",
  src: _imports_7
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, "Logga ut", -1)
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "p-3" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Kontakta oss"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "tel:020-252626" }, "020-25 26 26")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:info@ordnabolan.se" }, "info@ordnabolan.se")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    id: "menu",
    class: _normalizeClass(["sidebar", { 'menu-show': _ctx.showMenu }])
  }, [
    (!_ctx.username)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          _createElementVNode("li", _hoisted_2, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: { name: 'login' }
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _hoisted_4
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.username)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", { active: _ctx.isLinkActive('mortgage') }]),
              to: { name: 'mortgage_index' }
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8,
                (_ctx.badges.mortgage)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.badges.mortgage), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", { active: _ctx.isLinkActive('message') }]),
              to: { name: 'message_index' }
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _hoisted_12,
                (_ctx.badges.messages)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.badges.messages), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", _hoisted_14, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", { active: _ctx.isLinkActive('customer-offer') }]),
              to: { name: 'customer_offer_index' },
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.markMyPagesOfferAsViewed()))
            }, {
              default: _withCtx(() => [
                _hoisted_15,
                _hoisted_16,
                (_ctx.badges.customerOfferCount)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.badges.customerOfferCount), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", _hoisted_18, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", { active: _ctx.isLinkActive('mortgage/document') }]),
              to: { name: 'advisory_document_index' }
            }, {
              default: _withCtx(() => [
                _hoisted_19,
                _hoisted_20,
                (_ctx.badges.advisoryDocuments)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.badges.advisoryDocuments), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", _hoisted_22, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", { active: _ctx.isLinkActive('loan') }]),
              to: { name: 'loan_index' }
            }, {
              default: _withCtx(() => [
                _hoisted_23,
                _hoisted_24,
                (_ctx.badges.private)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.badges.private), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_26, [
      _createElementVNode("li", _hoisted_27, [
        (_ctx.username)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("span", null, _toDisplayString(_ctx.username), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("li", _hoisted_30, [
        (_ctx.username)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout())),
              class: _normalizeClass(["nav-link", { active: _ctx.isLinkActive() }])
            }, _hoisted_33, 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_34
  ], 2))
}